<header class="header">
  <div class="header__inner">
    <div class="header__brand">
      <a routerLink="/" class="header__logo" aria-label="Demag Product Advisor Home">
        <img src="images/Logo.png" alt="DEMAG">
      </a>

      @if (showRefBadge() && refId(); as currentRefId) {
        <div class="header__ref-badge">
          <span class="header__ref-badge-label">REF-ID</span>
          <span class="header__ref-badge-value">{{ currentRefId }}</span>
          <button
            type="button"
            class="header__ref-badge-btn"
            aria-label="Copy reference ID"
            (click)="copyRefId(currentRefId)"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.75"/>
              <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" stroke="currentColor" stroke-width="1.75"/>
            </svg>
          </button>
          <button type="button" class="header__ref-badge-btn" aria-label="Open reference">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" stroke="currentColor" stroke-width="1.75"/>
              <path d="M14 4h6v6M20 4 11 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      }
    </div>

    <div class="header__lang" [class.is-open]="isLangMenuOpen()" id="langDropdown">
      <button class="header__lang-btn" type="button" (click)="toggleLangMenu()">
        <span>{{ currentLanguageName() }}</span>
        <img src="images/icons/Language.png" alt="Language">
      </button>
      <div class="header__lang-dropdown">
        @for (language of languageList(); track language.lang_code) {
          <a
            href="#"
            class="header__lang-option"
            [class.header__lang-option--active]="language.lang_code === currentLanguage()"
            (click)="$event.preventDefault(); selectLanguage(language)"
          >{{ language.lang_name }}</a>
        }
      </div>
    </div>
  </div>
</header>

<div class="toasts" aria-live="polite">
  @for (notification of notifications(); track notification.id) {
    <div class="toast toast--{{ notification.type }}">
      <span class="toast__message">{{ notification.message }}</span>
      <button
        type="button"
        class="toast__close"
        aria-label="Dismiss notification"
        (click)="dismissNotification(notification.id)"
      >&times;</button>
    </div>
  }
</div>


